import type { ReferralMilestoneDef } from '../types/referral.ts';

export const REFERRAL_MILESTONES: Array<Omit<ReferralMilestoneDef, 'claimed' | 'can_claim'>> = [
  {
    milestone: 1,
    label: '1 Chỉ Huy Hợp Lệ',
    reward_type: 'boost',
    reward_id: 'boost_free_15m',
    reward_name: '2 Thẻ Tăng Tốc 15 Phút',
    reward_quantity: 2,
    description: 'Thưởng 2 vật phẩm tăng tốc 15 phút vào kho (rút ngắn 30 phút tiến độ nâng cấp/đóng tàu).',
  },
  {
    milestone: 3,
    label: '3 Chỉ Huy Hợp Lệ',
    reward_type: 'boost',
    reward_id: 'boost_free_30m',
    reward_name: '2 Thẻ Tăng Tốc 30 Phút',
    reward_quantity: 2,
    description: 'Thưởng 2 vật phẩm tăng tốc 30 phút vào kho (rút ngắn 60 phút tiến độ nâng cấp/đóng tàu).',
  },
  {
    milestone: 5,
    label: '5 Chỉ Huy Hợp Lệ',
    reward_type: 'ship_skin',
    reward_id: 'skin_ship_referral_vanguard',
    reward_name: 'Skin Tàu Tiên Phong Vanguard',
    reward_quantity: 1,
    description: 'Skin ngoại trang tàu chiến Tiên Phong Vanguard lục bảo độc quyền vĩnh viễn.',
  },
  {
    milestone: 10,
    label: '10 Chỉ Huy Hợp Lệ',
    reward_type: 'boost',
    reward_id: 'boost_free_60m',
    reward_name: '2 Thẻ Tăng Tốc 60 Phút',
    reward_quantity: 2,
    description: 'Thưởng 2 vật phẩm tăng tốc 60 phút vào kho (rút ngắn 120 phút tiến độ nâng cấp/đóng tàu).',
  },
  {
    milestone: 25,
    label: '25 Chỉ Huy Hợp Lệ',
    reward_type: 'galaxy_deco',
    reward_id: 'deco_galaxy_referral_crown',
    reward_name: 'Khung Vương Miện Thiên Hà',
    reward_quantity: 1,
    description: 'Khung đại diện Avatar Vương Miện Thiên Hà kim cương phát sáng độc quyền vĩnh viễn.',
  },
];
